<div class="modal-body premium-dialog-ui">
    <div class="form-row align-item-center">
        <div class="col-10 m-title col-md">
            <h5 class="general_sans mb-0">
                How It Works?
            </h5>
        </div>
        <div class="close-button" (click)="close()">
            <span class="material-icons">
                close
            </span>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-md-12 supports-row">
            <ul class="work-step">
                <li >
                    <div class="step_num">
                        <div class="step_inner"><span>1</span></div>
                        <div class="step_arrow">↓</div>
                    </div>
                    <div class="step_content">
                        <p>Select the desired Video/Card of your choice and Click “Edit For
                            Me”</p>
                    </div>
                </li>
                <li >
                    <div class="step_num">
                        <div class="step_inner"><span>2</span></div>
                        <div class="step_arrow">↓</div>
                    </div>
                    <div class="step_content">
                        <p>Kindly complete the form with your necessary details to facilitate
                            further
                            communication.</p>
                    </div>
                </li>
                <li >
                    <div class="step_num">
                        <div class="step_inner"><span>3</span></div>
                        <div class="step_arrow">↓</div>
                    </div>
                    <div class="step_content">
                        <p>You will be requested to sign-in or register if you are a new user.</p>
                    </div>
                </li>
                <li>
                    <div class="step_num">
                        <div class="step_inner"><span>4</span></div>
                        <div class="step_arrow">↓</div>
                    </div>
                    <div class="step_content">
                        <p>Complete Payment to Continue: Securely finalize your purchase by
                            proceeding
                            to the payment.
                        </p>
                    </div>
                </li>
                <li >
                    <div class="step_num">
                        <div class="step_inner"><span>5</span></div>
                    </div>
                    <div class="step_content">
                        <p>
                            Our team will reach out to collect your images and text for
                            personalized
                            video invitations or Whatsapp Us on <a href="tel:+918669278777">+9195275 27889</a>
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>